import React from "react";

function IrregularityReason() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      enableBackground="new 0 0 512 512"
      viewBox="0 0 60 60"
    >
      <rect
        width="48"
        height="55"
        x="6"
        y="4"
        fill="#9e785f"
        data-original="#9e785f"
        rx="2"
      ></rect>
      <path
        fill="#f0f2f5"
        d="M11 8a1 1 0 00-1 1v45a1 1 0 001 1h31.586a1 1 0 00.707-.293l6.414-6.414a1 1 0 00.293-.707V9a1 1 0 00-1-1z"
        data-original="#f0f2f5"
      ></path>
      <path
        fill="#faa116"
        d="M30.665 31h-15.33a1.386 1.386 0 01-1.142-2.1l7.664-13.228a1.305 1.305 0 012.286 0L31.807 28.9a1.386 1.386 0 01-1.142 2.1zm0 20h-15.33a1.386 1.386 0 01-1.142-2.1l7.664-13.228a1.305 1.305 0 012.286 0L31.807 48.9a1.386 1.386 0 01-1.142 2.1z"
        data-original="#faa116"
      ></path>
      <rect
        width="16"
        height="9"
        x="22"
        y="1"
        fill="#ccd0da"
        data-original="#ccd0da"
        rx="2"
      ></rect>
      <path
        fill="#ccd0da"
        d="M49.9 48a.812.812 0 01-.19.29l-6.42 6.42a.812.812 0 01-.29.19V49a1 1 0 011-1z"
        data-original="#ccd0da"
      ></path>
      <path
        fill="#fff"
        d="M23 24a1 1 0 01-1-1v-3a1 1 0 012 0v3a1 1 0 01-1 1zm0 4a1 1 0 01-1-1v-.406a1 1 0 012 0V27a1 1 0 01-1 1zm0 16a1 1 0 01-1-1v-3a1 1 0 012 0v3a1 1 0 01-1 1zm0 4a1 1 0 01-1-1v-.406a1 1 0 112 0V47a1 1 0 01-1 1z"
        data-original="#ffffff"
      ></path>
      <path
        fill="#b9bfcc"
        d="M45 18H35a1 1 0 010-2h10a1 1 0 010 2zm0 4H35a1 1 0 010-2h10a1 1 0 010 2zm-5 4h-5a1 1 0 010-2h5a1 1 0 010 2zm5 12H35a1 1 0 010-2h10a1 1 0 010 2zm0 4H35a1 1 0 010-2h10a1 1 0 010 2zm-5 4h-5a1 1 0 010-2h5a1 1 0 010 2z"
        data-original="#b9bfcc"
      ></path>
    </svg>
  );
}

export default IrregularityReason;